'use client';

import * as React from 'react';
import EmojiPicker, { Theme } from 'emoji-picker-react';

interface EmojiPickerComponentProps {
  onEmojiClick: (emoji: string) => void;
}

export function EmojiPickerComponent({ onEmojiClick }: EmojiPickerComponentProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const pickerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleEmojiClick = (emojiData: any) => {
    const chatInput = document.querySelector('.lk-chat-form-input') as HTMLInputElement;
    const currentValue = chatInput?.value || '';
    const currentSelectionStart = chatInput?.selectionStart || 0;
    const currentSelectionEnd = chatInput?.selectionEnd || 0;

    onEmojiClick(emojiData.emoji);
    setIsOpen(false);

    setTimeout(() => {
      if (chatInput) {
        if (chatInput.value !== currentValue) {
          const newValue =
            currentValue.slice(0, currentSelectionStart) +
            emojiData.emoji +
            currentValue.slice(currentSelectionEnd);
          chatInput.value = newValue;

          const inputEvent = new Event('input', { bubbles: true });
          const changeEvent = new Event('change', { bubbles: true });
          chatInput.dispatchEvent(inputEvent);
          chatInput.dispatchEvent(changeEvent);
        }

        const newPosition = currentSelectionStart + emojiData.emoji.length;
        chatInput.setSelectionRange(newPosition, newPosition);
        chatInput.focus();
      }
    }, 50);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div ref={pickerRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={handleButtonClick}
        type="button"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '20px',
          padding: '4px 8px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: isOpen ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          transition: 'background-color 0.2s ease',
        }}
        title="Adicionar emoji"
      >
        😀
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '0',
            marginBottom: '8px',
            zIndex: 9999,
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            theme={Theme.DARK}
            width={320}
            height={400}
            searchDisabled={false}
            skinTonesDisabled={false}
            previewConfig={{
              showPreview: false,
            }}
          />
        </div>
      )}
    </div>
  );
}
